import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import MetaDecorator from 'apps/home/components/MetaDecorator';
import PageTitle from 'apps/home/components/PageTitle';
import ErrorMessage from 'common/ui/ErrorMessage';
import LoadingSpinner from 'common/ui/LoadingSpinner';
import { useFetchApiGet } from 'hooks/api';
import { Contribute } from './portfolio-detail';

function ProgramDetailPortfolio({ apiCall }) {
  const title = 'Employee Program Portfolio';
  const params = useParams();
  const { data, isLoading: isLoadingPort, error: errorPort, load } = useFetchApiGet(
    apiCall.portfolio,
    { resourceName: 'data' }
  );

  useEffect(() => {
    if (params.id) load(params);
  }, [params.id]);

  if (isLoadingPort || (!data && !errorPort)) {
    return <LoadingSpinner />;
  }
  if (errorPort) {
    return <ErrorMessage errors={errorPort} />;
  }

  const { total_summary, company_summary, employee_summary } = data || {};
  return (
    <div className="flex flex-col gap-6">
      <MetaDecorator title={title} />
      <PageTitle title={title} backUrl={`/futureflex/employee-programs`} />
      <Contribute {...total_summary} />
      <Contribute {...company_summary} />
      <Contribute {...employee_summary} />
    </div>
  );
}

export default ProgramDetailPortfolio;
